import { localUrl as appLocalUrl } from '../app-path.js';
import 'lazysizes'

import Slugify from 'slugify'
import geolocation from './geolocation'
import { getGenericData, getUserViewData, SearchedStorage, setViewData, trackUserView } from './local-storage-functions'
import { initializeForecastFavoriteButton } from './favorite-city-utils.js'
import { autocomplete } from './autocompletev2.js'
import LocalStorageHelper from './local-storage-helper.js'
import geolocationInstructionsModal from './geolocation-instructions-modal.js'

let moreDaysButtonsBound = false
let consentSettingsBound = false

const common = {
  /**
   * Create slug from string
   *
   */
  createSlug: (string) => {
    const slug = Slugify(string, {
      remove: /[ \']/g,
      url: true,
      lower: true,
    });

    return slug;
  },
  /**
   * Controla eventos de scroll na página (lazyload)
   *
   */
  backToTopButton: () => {
    const backToTopButton = $(".back-to-top-button");
    if (!backToTopButton.length) return;

    let isVisible = false;
    let suppressUntilBelow = false;
    let hasReportedShow = false;
    window.dataLayer = window.dataLayer || [];

    const thresholdPx = () => {
      const winH = window.innerHeight || 0;
      // Mostra depois de ~40% da tela ou mínimo de 200px e máximo de 400px
      return Math.max(200, Math.min(400, winH * 0.4));
    };

    const handleVisibility = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      const shouldShow = scrollTop >= thresholdPx();

      if (suppressUntilBelow && shouldShow) {
        return;
      }

      if (shouldShow && !isVisible) {
        backToTopButton.css("display", "flex");
        if (!hasReportedShow) {
          window.dataLayer.push({
            event: "show_element",
            id: "Control_FloatNav_Button_BackToTop",
          });
          hasReportedShow = true;
        }
        isVisible = true;
        return;
      }

      if (!shouldShow && isVisible) {
        backToTopButton.css("display", "none");
        isVisible = false;
      }

      if (!shouldShow) {
        suppressUntilBelow = false;
      }
    };

    window.addEventListener("scroll", handleVisibility, { passive: true });
    handleVisibility(); // checa estado inicial (páginas longas carregadas no meio)

    backToTopButton.on("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      window.dataLayer.push({
        event: "click_button",
        id: "Control_FloatNav_Button_BackToTop",
      });

      backToTopButton.css("display", "none");
      isVisible = false;
      suppressUntilBelow = true;
    });
  },

  applyWindRotationIndicators: (root = document) => {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document
    if (!scope) return

    scope.querySelectorAll('[data-wind-rotation]').forEach((element) => {
      const angle = Number(element.getAttribute('data-wind-rotation'))
      if (Number.isNaN(angle)) return
      element.style.transform = `rotate(${angle}deg)`
    })
  },

  applyDataStyleAttributes: (root = document) => {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document
    if (!scope) return

    const styleAttributes = [
      ['data-style-display', 'display'],
      ['data-style-height', 'height'],
      ['data-style-width', 'width'],
      ['data-style-min-height', 'minHeight'],
      ['data-style-max-width', 'maxWidth'],
      ['data-style-z-index', 'zIndex'],
    ]

    styleAttributes.forEach(([attributeName, propertyName]) => {
      scope.querySelectorAll(`[${attributeName}]`).forEach((element) => {
        const value = element.getAttribute(attributeName)
        if (!value) return
        element.style[propertyName] = value
      })
    })

    scope.querySelectorAll('[data-css-var-name]').forEach((element) => {
      const propertyName = element.getAttribute('data-css-var-name')
      const propertyValue = element.getAttribute('data-css-var-value')

      if (!propertyName || !propertyValue) return
      element.style.setProperty(propertyName, propertyValue)
    })
  },

  bindMoreDaysButtons: () => {
    if (moreDaysButtonsBound || typeof document === 'undefined') return
    moreDaysButtonsBound = true

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-more-days-target], [data-hide-on-click]')
      if (!trigger) return

      if (trigger.hasAttribute('data-more-days-target') || trigger.hasAttribute('data-hide-on-click')) {
        trigger.classList.add('_none')
      }

      const targetId = trigger.getAttribute('data-more-days-target')
      if (!targetId) return

      const target = document.getElementById(targetId)
      if (target) target.classList.add('_padding-b-off')
    })
  },

  bindConsentSettingsActions: () => {
    if (consentSettingsBound || typeof document === 'undefined') return
    consentSettingsBound = true

    $(document).on('click', '[data-open-consent-settings]', function (event) {
      event.preventDefault()

      if (window.__lxG__consent__ !== undefined && window.__lxG__consent__.getState() !== null) {
        window.__lxG__consent__.showConsent()
        return
      }

      window.alert('This function only for users from European Economic Area (EEA)')
    })
  },

  onScroll: () => {
    const screenHeight = $(window).height();

    const stickyDesktop = $("[data-banner=stickBannerDesktop");
    const stickyMobile = $("[data-banner=stickBannerMobile");
    const stickyMobileBottom = $("[data-banner=stickBannerMobileBottom");
    const fakeSticky = $("[data-banner=fake-sticky]");

    let beginStickyMobile = 0;
    let endStickyMobile = 0;
    let beginStickyMobileBottom = 0;
    let endStickyMobileBottom = 0;

    // verifica se tem sticky na página
    if (stickyMobile.length) {
      beginStickyMobile = stickyMobile.offset().top;
      endStickyMobile = $("[data-end-sticky-banner-mobile]").offset().top;
    }

    if (stickyMobileBottom.length) {
      beginStickyMobileBottom =
        $("[data-end-sticky-banner-mobile]").offset().top + 60;
      endStickyMobileBottom = $(".footer-site").offset().top - 300;
    }

    document.addEventListener(
      "scroll",
      function (e) {
        let scroll = $(window).scrollTop();

        if (stickyDesktop.length) {
          if (scroll > 200) stickyDesktop.removeClass("-hidden");
        }

        // verifica se tem sticky na página
        if (fakeSticky.length) {
          let fakeStickyPosition = $("[data-control-fake-sticky]").offset().top;

          scroll >= fakeStickyPosition - (screenHeight - 90)
            ? fakeSticky.find(".-close-banner").removeClass("_flex")
            : fakeSticky.find(".-close-banner").addClass("_flex");

          if (scroll > 200) fakeSticky.removeClass("-hidden");
        }

        if (stickyMobile.length) {
          scroll >= beginStickyMobile
            ? stickyMobile.addClass("_fixed")
            : stickyMobile.removeClass("_fixed");

          scroll >= endStickyMobile + 60
            ? stickyMobile.addClass("-hidden")
            : stickyMobile.removeClass("-hidden");
        }

        if (stickyMobileBottom.length) {
          scroll >= beginStickyMobileBottom
            ? stickyMobileBottom.addClass("_fixed")
            : stickyMobileBottom.removeClass("_fixed");
          scroll >= endStickyMobileBottom
            ? stickyMobileBottom.addClass("-hidden")
            : stickyMobileBottom.removeClass("-hidden");
        }

        $("[data-counter]").each(function () {
          let offset = $(this).offset().top - 100;
          let activated = $(this).hasClass("-activated");

          if (scroll > offset && !activated) {
            const total = $(this).data("total");

            $(this).addClass("-activated");

            $(this)
              .prop("counter", 0)
              .animate(
                { counter: total },
                {
                  duration: 2500,
                  easing: "swing",
                  step: function (now) {
                    $(this).text(Math.ceil(now));
                  },
                }
              );
          }
        });
      },
      { passive: true }
    );
  },

  /**
   * Controla abertura da pesquisa mobile
   *
   */
  controlMobileSearch: () => {
    $(document).on("click", ".act-control-mobile-search", function () {
      const $wrapper = $(`[data-id='mobile-search']`);
      if (!$wrapper.length) return;
      const willOpen = !$wrapper.is(":visible");
      $wrapper.slideToggle("fast");
      $(this).attr("aria-expanded", willOpen ? "true" : "false");
    });
  },

  /**
   * Fecha um banner
   *
   */
  closeBanner: () => {
    $("[data-close-banner]").click(function () {
      $(this).parent().remove();
    });

    $("[data-close-fake-sticky]").click(function () {
      $(this).parent().parent().addClass("_relative");
      $(this).remove();
    });
  },


  autocompleteSearchV2: () => {
    autocomplete()
  },

  activeTab: () => {
    const tab = $("[data-page=has-tab]").data("tab");
    $('[data-item="' + tab + '"]').addClass("-active");
  },

  activeMobileTab: () => {
    const tab = $("[data-page=has-tab]").data("tab");

    if (tab) {
      const left = $('[data-navigation="' + tab + '"]')
        .addClass("-active")
        .offset().left;

      const innerWidth = window.innerWidth;
      const scrollLeft = innerWidth / 2 - 60;
      const fixedNavigation = document.getElementById("fixedNavigation");

      fixedNavigation.addEventListener(
        "scroll",
        (ev) => {
          let scroll = ev.target.scrollLeft;
          const left = document.getElementById("sideNavigatorLeft");
          const right = document.getElementById("sideNavigatorRight");

          if (scroll < 50) left.classList.add("-hidden");
          else left.classList.remove("-hidden");

          if (scroll > 350) right.classList.add("-hidden");
          else right.classList.remove("-hidden");
        },
        { passive: true }
      );

      fixedNavigation.scrollTo({
        left: left - scrollLeft,
        behavior: "smooth",
      });
    }
  },
  centerAgg15Nav: () => {
    if (window.innerWidth > 991) return;

    const wrapper = document.querySelector(".tabs-15-agg-wrapper");
    if (!wrapper) return;

    const list = wrapper.querySelector(".list-tabs.-agg-15-nav");
    if (!list) return;

    const activeItem = list.querySelector(".item.-active");

    if (!activeItem) return;

    const centerActive = () => {
      const scrollContainer = wrapper || activeItem.parentElement;
      const containerRect = scrollContainer.getBoundingClientRect();
      const activeRect = activeItem.getBoundingClientRect();
      const currentScroll = scrollContainer.scrollLeft;
      const offset = activeRect.left - containerRect.left;
      const targetScroll =
        currentScroll +
        offset +
        activeRect.width / 2 -
        containerRect.width / 2;
      const maxScroll =
        scrollContainer.scrollWidth - scrollContainer.clientWidth;
      const clampedScroll = Math.max(0, Math.min(targetScroll, maxScroll));

      if (maxScroll <= 0) return;

      scrollContainer.scrollTo({
        left: clampedScroll,
        behavior: "smooth",
      });
    };

    requestAnimationFrame(centerActive);
    setTimeout(centerActive, 150);
    window.addEventListener("load", centerActive, { once: true });
  },

  fallbackImage: () => {
    $(".fallback").on("error", function () {
      const imageElement = $(this);
      const imageFallback = imageElement.data("fallback");

      if (imageFallback) {
        imageElement.attr("src", imageFallback);
      }
    });
  },

  insertImgAlt: () => {
    document.addEventListener("DOMContentLoaded", function () {
      function adicionarAltNasImagens() {
        const imagens = document.querySelectorAll("img");
        imagens.forEach(function (img, index) {
          if (!img.hasAttribute("alt")) {
            img.setAttribute("alt", "Imagem de anuncio: " + (index + 1));
          }
        });
      }

      const observer = new MutationObserver(function (mutationsList) {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach(function (node) {
              if (node.tagName === "IMG" && !node.hasAttribute("alt")) {
                node.setAttribute("alt", "Imagem de anuncio");
              } else if (node.querySelectorAll) {
                node.querySelectorAll("img").forEach(function (img) {
                  if (!img.hasAttribute("alt")) {
                    img.setAttribute("alt", "Imagem de anuncio");
                  }
                });
              }
            });
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      adicionarAltNasImagens();
    });
  },

  insertIframeTitle: () => {
    document.addEventListener("DOMContentLoaded", function () {
      function adicionarTitleNosIframes() {
        const iframes = document.querySelectorAll("iframe");
        iframes.forEach(function (iframe, index) {
          if (!iframe.hasAttribute("title")) {
            iframe.setAttribute("title", "Iframe number: " + (index + 1));
          }
        });
      }

      const observer = new MutationObserver(function (mutationsList) {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach(function (node) {
              if (node.tagName === "IFRAME" && !node.hasAttribute("title")) {
                node.setAttribute("title", "Titulo do Iframe");
              } else if (node.querySelectorAll) {
                node
                  .querySelectorAll("iframe")
                  .forEach(function (iframe, index) {
                    if (!iframe.hasAttribute("title")) {
                      iframe.setAttribute(
                        "title",
                        "Iframe number: " + (index + 1)
                      );
                    }
                  });
              }
            });
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      adicionarTitleNosIframes();
    });
  },

  handleFavoriteButtonClick: () => {

    function forceInitializeFavoriteButton() {
      const button = document.getElementById('forecastFavButton');
      if (button) {
        delete button.dataset.initialized;
        initializeForecastFavoriteButton();
        button.dataset.initialized = 'true';
      }
    }

    function monitorFavoriteButton() {
      const observer = new MutationObserver(() => {
        const button = document.getElementById('forecastFavButton');
        if (button && !button.dataset.initialized) {
          initializeForecastFavoriteButton();
          button.dataset.initialized = 'true';
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      monitorFavoriteButton();
      forceInitializeFavoriteButton();
    });

    $(document).on('click', '[data-item]', function () {
      setTimeout(() => {
        forceInitializeFavoriteButton();
      }, 100);
    });
  },

  userLocationStepByStep: async () => {
    const button = {
      location: $("#locateUserButton"),
      yes: $("#yesButton"),
      no: $("#noButton"),
      instruction: $("#instructionButton"),
      modalClose: $("#closeGeolocationInstructionsModal"),
      useMyCurrentLocation: $("#useMyCurrentLocationButton"),
    };

    const step = {
      question: $("#questionStep"),
      yesThanks: $("#yesThanksStep"),
      noThanks: $("#noThanksStep"),
      instruction: $("#instructionStep"),
      useMyCurrentLocation: $("#useMyCurrentLocationStep"),
    };

    const modal = $("#geolocationInstructionsModal");

    const geolocationStatus = await navigator.permissions
      .query({ name: "geolocation" })
      .then((result) => result.state);

    switch (geolocationStatus) {
      case "granted":
        step.useMyCurrentLocation.css("display", "none");
        step.question.css("display", "flex");
        break;
      case "denied":
        step.question.css("display", "none");
        step.useMyCurrentLocation.css("display", "flex");
        break;
      case "prompt":
        const requestedLocation = localStorage.getItem("requestedLocation");
        if (requestedLocation === "true") {
          navigator.geolocation.getCurrentPosition(
            async (pos) => {
              const data = await geolocation.userGeolocation(true);
              console.log(data);
              geolocation.renderWeatherNowByGeolocation();
            },
            (err) => console.error(err)
          );
        }

        break;
    }

    button.location.on("click", async () => {
      const triggerId = button.location?.attr("data-id") || button.location?.attr("id") || "page_view";
      const geolocationStatus = await navigator.permissions
        .query({ name: "geolocation" })
        .then((result) => result.state);

      if (geolocationStatus === "prompt") {
        if ("geolocation" in navigator) {
          trackUserView(triggerId);
        }

        return;
      }

      const storedSearchedCities = SearchedStorage.get();
      const lastSearchedCity = storedSearchedCities?.[0];

      if (lastSearchedCity) {
        geolocation.renderWeatherNowByGeolocation(
          lastSearchedCity.cloc,
          lastSearchedCity.cid
        );

        if (lastSearchedCity.clat && lastSearchedCity.clon) {
          LocalStorageHelper.set("last_known_location", {
            lat: lastSearchedCity.clat,
            lon: lastSearchedCity.clon,
          });

          console.log(
            'Definida "last_known_location" com base na última cidade pesquisada:',
            lastSearchedCity.cname
          );
        }

        const genericData = getGenericData("geolocation");
        genericData.city = lastSearchedCity;
        genericData.is_fallback = false;
        setViewData(genericData);
        console.log(
          "Visualização registrada para a última cidade pesquisada:",
          lastSearchedCity.cname
        );
      } else {
        trackUserView(triggerId);
      }

      step.initial.hide();
      step.question.css("display", "flex");
    });

    button.yes.on("click", () => {
      step.question.hide();
      step.yesThanks.css("display", "flex");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_button",
        id: "Survey_WeatherNowLocations_Button_Yes",
      });
    });

    button.no.on("click", async () => {
      step.question.hide();
      step.noThanks.css("display", "flex");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_button",
        id: "Survey_WeatherNowLocations_Button_No",
      });
    });

    button.instruction.on("click", () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_button",
        id: button.instruction?.data("id") || "Card_WeatherNow_Button_ClickHere",
      });
      geolocationInstructionsModal.open();
    });

    button.modalClose.on("click", () => {
      modal.hide();
    });

    const resolveWeatherNowLocationId = async () => {
      try {
        const status = await navigator.permissions.query({ name: "geolocation" });
        if (status?.state === "granted") {
          return "Card_WeatherNow_Button_Location";
        }
      } catch (e) {}
      return "Card_WeatherNow_Button_UseLocation";
    };

    resolveWeatherNowLocationId().then((id) => {
      button.useMyCurrentLocation.attr("data-id", id);
    });

    button.useMyCurrentLocation.on("click", async (e) => {
      const method = await resolveWeatherNowLocationId();
      button.useMyCurrentLocation.attr("data-id", method);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_button",
        id: method,
      });

      let status = (await navigator.permissions.query({ name: "geolocation" })).state;
      if (status === "prompt") {
         await navigator.geolocation.getCurrentPosition(
          async () => {
            await geolocation.userGeolocation(true, { method });
            geolocation.renderWeatherNowByGeolocation();
          }
        );
      } else if (status === "denied") {
        geolocationInstructionsModal.open();    
      } else {
        return
      }
    });

    modal.on("click", (e) => {
      if (e.target.id === "geolocationInstructionsModal") modal.hide();
    });
  },

  setAlertStyle: () => {
    const alertTitleWrapper = $("#alertTextWrapper");
    const alertTitle = $("#alertText");

    if (
      alertTitle[0] &&
      alertTitle[0].scrollWidth > alertTitleWrapper.width()
    ) {
      alertTitle.last().addClass("marquee");
    }

    const alertButton = $("#alert");
    const alertBg = $(".alert-modal-background");
    const alertBody = $(".alert-body");

    alertButton.on('click', () => {
      alertBg.toggleClass('active');
      alertBody.toggleClass('active');
    })
  },

  viewData: () => {
    getUserViewData(window?.pageData?.infoCity);

  },

  controlMobileMenu: () => {
    $(document).on('click', '.actControlMobileMenu', function () {
      const menu = $(this).data('menu')
      const after = $(this).data('after')

      $('#listSubMenusMobile.clone').remove()

      let $area = $('#listSubMenusMobile').clone().addClass('clone')

      $(`[data-sub-menu=${menu}]`).each(function () {
        let item = $(this).clone()

        $area.append(item)
      })

      $('.item-mobile').addClass('-opacity')
      $(this).removeClass('-opacity')

      $(`[data-index-menu=${after}]`).after($area)
    })
  },

  initMetrics: () => {
    common.bindConsentSettingsActions()

    $(document).ready(function () {

      $('.actTriggerGA').click(function () {
        const category = $(this).data('category')
        const label = $(this).data('label')
        const action = $(this).data('action')
      });

    })
  },

  dynamicLink: (idcity, name, uf = '') => {
    const slugBody = $('body').data('slug')
    const slugBreadcrumb = `${idcity}/${common.createSlug(name)}-${uf.toLowerCase()}`

    const slug = slugBody ? slugBody : slugBreadcrumb

    $('[data-dynamic-link]').each(function () {
      let href = $(this).data('link').replace('{slug}', slug)
      $(this).attr('href', appLocalUrl(href))
    })

    $('[data-dynamic-news-link]').each(function () {
      // const widthScreen = $(window).width()
      const href = $(this).data('link')

      let prefix = appLocalUrl('/noticia')
      if (href.startsWith('https://agroclima.climatempo.com.br/')) {
        $(this).attr('href', `${href}`)
      } else {
        $(this).attr('href', `${prefix}/${href}`)
      }
    })

    $('[data-dynamic-agroclima-news-link]').each(function () {
      const href = $(this).data('link');
      const url = href.startsWith('https://agroclima.climatempo.com.br/')
        ? href
        : `https://agroclima.climatempo.com.br/noticia/${href.replace(/^\/+/, '')}`;
      $(this).attr('href', url);
    })
  },
}

function isMobile() {
  return /android|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i.test(navigator.userAgent);
}

export default common;
